import { sortApiNamesByProductLevel } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const getApiName = (featureTranslations, productLevel) => {
  if (productLevel) {
    const productFromLevel = Object.keys(featureTranslations).find(key => key.includes(productLevel.toLocaleLowerCase()));
    if (productFromLevel) {
      return productFromLevel;
    }
  }
};
const getFeatureTranslationByAttribute = (feature, attribute, productLevel) => {
  const featureKey = attribute === 'description' ? 'descriptions' : attribute;
  const {
    [featureKey]: featureTranslations
  } = feature;
  if (!featureTranslations) {
    return null;
  }
  const apiName = getApiName(featureTranslations, productLevel);
  const translation = apiName && featureTranslations[apiName];
  if (translation) {
    return translation;
  }

  // fallback
  const highestTierProduct = sortApiNamesByProductLevel(feature.productApiNames).at(-1);
  return highestTierProduct && featureTranslations[highestTierProduct];
};
const TranslatedFeature = ({
  feature,
  attribute,
  productLevel,
  useFeatureStore = true
}) => {
  if (useFeatureStore) {
    if (attribute === 'name') return /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: {
        __html: feature.displayName
      },
      "data-test-id": "translated-feature"
    });
    const translation = getFeatureTranslationByAttribute(feature, attribute, productLevel);
    if (translation) {
      return /*#__PURE__*/_jsx("span", {
        dangerouslySetInnerHTML: {
          __html: translation
        },
        "data-test-id": "translated-feature"
      });
    }
    return null;
  }
  return null;
};
export default TranslatedFeature;